import React, { useEffect } from "react";
import {
  createStyles,
  Grid,
  makeStyles,
  TextField,
  Theme,
  Box,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { RequestHeader } from "./newRequestHeader";
import { NewRequestToolsGrid } from "./newRequestToolsGrid";
import { NewRequestGrid } from "./newRequestGrid";
import { useAppData } from "../../services/hooks";
import { ApproveCommentModel } from "./newRequestApproveCommentModel";
import { useDispatch } from "react-redux";
import { debounce } from "lodash";
import {
  getNewRequest_stateAction,
  submitDataAction,
  getNewRequest_suppliersAction,
} from "../toolDisposalSlice";
import moment from "moment";

const willPolaris = [
  { willPolarisReceiveCredit: "true" },
  { willPolarisReceiveCredit: "false" },
];
const partResponsible = [
  { partyResponsibleForDisposition: "Supplier" },
  { partyResponsibleForDisposition: "Polaris" },
];
export const RightSection = ({ paramsData, requester }): JSX.Element => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const productLinese = useAppData(
    (r) => r.toolDisposalSlice.toolInformation.productLinesValue
  );
  const toolTypesValue = useAppData(
    (r) => r.toolDisposalSlice.toolInformation.toolTypesValue
  );
  const countriesValue = useAppData(
    (r) => r.toolDisposalSlice.toolInformation.countriesValue
  );
  const projectNumberValue = useAppData(
    (r) => r.toolDisposalSlice.toolInformation.projectNumberValue
  );
  const supplierValue = useAppData(
    (r) => r.toolDisposalSlice.toolInformation.suppliersValue
  );
  const supplierNumberValue = useAppData(
    (r) => r.toolDisposalSlice.toolInformation.suppliersNumberValue
  );
  const statesValue = useAppData(
    (r) => r.toolDisposalSlice.toolInformation.statesValue
  );
  const row = useAppData((r) => r.toolDisposalSlice.updateValues.value);
  const header1 = "TOOL INFORMATION";
  const header = "DISPOSAL INFORMATION";

  const createTagHandler =
    (
      tagType:
        | "supplierNumber"
        | "toolTypeId"
        | "poNumber"
        | "productLines"
        | "totalPOValue"
        | "projectNumber"
        | "lastUsedDate"
        | "reasonForDisposition"
        | "estToolScrapValue"
        | "partyResponsibleForDisposition"
        | "willPolarisReceiveCredit"
        | "explainationForScrapAggrement"
        | "supplierName"
        | "countryToolResidesInName"
    ) =>
    (value: any) => {
      const { ...rowdata } = row;
      if (tagType === "supplierName") {
        dispatch(
          submitDataAction({
            body: {
              ...rowdata,
              supplierName: value.supplierName,
              supplierNumber: value.supplierNumber,
            },
          })
        );
      } else if (tagType === "toolTypeId") {
        dispatch(
          submitDataAction({
            body: {
              ...rowdata,
              toolTypeId: value.toolTypeId,
              toolType: value.toolType,
            },
          })
        );
      } else if (tagType === "countryToolResidesInName") {
        dispatch(
          submitDataAction({
            body: {
              ...rowdata,
              countryToolResidesInName: value,
            },
          })
        );
      } else {
        dispatch(
          submitDataAction({
            body: {
              ...rowdata,
              [tagType]: value,
            },
          })
        );
      }
    };

  const handleReasonForDisposition = createTagHandler("reasonForDisposition");
  const handleEstToolScrapValue = createTagHandler("estToolScrapValue");

  const handlePartyResponsibleForDisposition = createTagHandler(
    "partyResponsibleForDisposition"
  );
  const handleWillPolarisReceiveCredit = createTagHandler(
    "willPolarisReceiveCredit"
  );
  const handleExplainationForScrapAggrement = createTagHandler(
    "explainationForScrapAggrement"
  );

  const lastUsedDate = row.lastUsedDate;
  const lastUsedDateFormatted = lastUsedDate ? moment(lastUsedDate)
    .utc()
    .format("YYYY-MM-DD") : '';

  function handleCountryChange(value: any) {
    dispatch(getNewRequest_stateAction(value));
  }

  let rowDisposal = {
    ...row,
    partyResponsibleForDisposition:
      row.partyResponsibleForDisposition === null
        ? ""
        : row.partyResponsibleForDisposition,
  };
  const updatedTool = toolTypesValue.map((object) => {
    return {
      toolType: object.description,
      toolTypeId: object.id,
    };
  });
  const productLineseUpdated = productLinese.map((object) => {
    return {
      ...object,
      productLines: object.name,
    };
  });

  const projectNumberUpdated = projectNumberValue.map((object) => {
    return {
      ...object,
      projectNumber: object.number,
    };
  });

  const countriesValueUpdated = countriesValue.map((object) => {
    return {
      ...object,
      countryToolResidesIn: object.code,
      countryToolResidesInName: object.name,
    };
  });

  const stateToolResidesInUpdated = statesValue.map((object) => {
    return {
      stateToolResidesIn: object.code,
      stateToolResidesInName: object.name,
    };
  });

  const handleSupplierDebounce = debounce((value) => {
    value.length > 2 && dispatch(getNewRequest_suppliersAction(value));
  }, 1000);

  const merge = (...arrays) => {
    const merged = {};

    arrays.forEach((data) =>
      data.forEach((o) => Object.assign((merged[o.supplierNumber] ??= {}), o))
    );

    return Object.values(merged);
  };
  let totalSupplierData = merge(supplierNumberValue, supplierValue);

  useEffect(() => {
    if (row && row.requester && countriesValue.length > 0) {
      let country = countriesValue.filter((item) => {
        return item.code === row.countryToolResidesIn;
      });

      let conName = country && country[0] && country[0].name;
      //handleCountryToolResidesInName(conName);
    }
  }, [row.countryToolResidesIn, countriesValue]);

  useEffect(() => {
    handleCountryChange(row.countryToolResidesIn);
  }, [row.countryToolResidesIn]);

  useEffect(() => {
    if (
      toolTypesValue &&
      toolTypesValue.length > 0 &&
      row &&
      row.toolTypeId != undefined &&
      row.countryToolResidesInName
    ) {
      let tool = toolTypesValue.filter((item) => {
        return item.id === row.toolTypeId;
      });
      let tooObj = {
        toolType: tool[0].description,
        toolTypeId: tool[0].id,
      };
      //handleToolTypeId(tooObj);
    }
  }, [toolTypesValue, row.toolTypeId, row.countryToolResidesInName]);

  const stateUseEffect = () => {
    let state = stateToolResidesInUpdated.filter((item) => {
      return item.stateToolResidesIn === row.stateToolResidesIn;
    });
    //state.length > 0 && handleStateToolResidesIn(state[0]);
  };

  useEffect(() => {
    setTimeout(stateUseEffect, 1500);
  }, [stateToolResidesInUpdated.length > 0]);
  return (
    <div className={classes.filterWrapper}>
      <Box data-tut={"reactour__dispositionInformation"}>
        <Grid item>
          {" "}
          <RequestHeader header={header} />{" "}
        </Grid>
        <Grid
          container
          direction={"column"}
          spacing={2}
          data-tut={"reactour__filter-Module"}
        >
          <Grid item>
            <TextField
              fullWidth
              disabled={
                paramsData.disposalStatusId === "2" ||
                paramsData.disposalStatusId === "3" ||
                paramsData.disposalStatusId === "4" ||
                (!requester &&
                  (paramsData.disposalStatusId === "3" ||
                    paramsData.disposalStatusId === "4"))
                  ? true
                  : false
              }
              value={
                row.reasonForDisposition === null ||
                row.reasonForDisposition === undefined
                  ? ""
                  : row.reasonForDisposition
              }
              inputProps={{maxLength: 500}}
              multiline
              required
              maxRows={4}
              label="Description - Reason for Request"
              variant="outlined"
              onChange={(event) =>
                handleReasonForDisposition(event.target.value)
              }
            />
          </Grid>

          <Grid item>
            <Grid container direction={"row"} spacing={2}>
              <Grid item xs={12} md={6} lg={6}>
                <Grid container direction={"column"} spacing={2}>
                  <Grid item>
                    <TextField
                      type="number"
                      disabled={
                        paramsData.disposalStatusId === "2" ||
                        paramsData.disposalStatusId === "3" ||
                        paramsData.disposalStatusId === "4" ||
                        (!requester &&
                          (paramsData.disposalStatusId === "3" ||
                            paramsData.disposalStatusId === "4"))
                          ? true
                          : false
                      }
                      fullWidth
                      value={
                        !row.estToolScrapValue ? "" : row.estToolScrapValue
                      }
                      label="Estimated Tool Scrap Value"
                      required
                      variant="outlined"
                      onChange={(event) =>
                        handleEstToolScrapValue(event.target.value)
                      }
                    />
                  </Grid>
                  <Grid item>
                    <Autocomplete
                      id="party-responsible-for-disposition-select"
                      disabled={
                        paramsData.disposalStatusId === "2" ||
                        paramsData.disposalStatusId === "3" ||
                        paramsData.disposalStatusId === "4" ||
                        (!requester &&
                          (paramsData.disposalStatusId === "3" ||
                            paramsData.disposalStatusId === "4"))
                          ? true
                          : false
                      }
                      clearOnBlur
                      value={rowDisposal}
                      aria-label={"party-responsible-for-disposition-select"}
                      fullWidth
                      options={partResponsible}
                      getOptionLabel={(option) =>
                        option.partyResponsibleForDisposition
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          required
                          label="Party Responsible for Disposal"
                          variant="outlined"
                        />
                      )}
                      onChange={(event, options) => {
                        if (!options) {
                          return;
                        }
                        handlePartyResponsibleForDisposition(
                          options.partyResponsibleForDisposition as string
                        );
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <Grid container direction={"column"} spacing={2}>
                  <Grid item>
                    <Autocomplete
                      id="part-number-select"
                      disabled={
                        paramsData.disposalStatusId === "2" ||
                        paramsData.disposalStatusId === "3" ||
                        paramsData.disposalStatusId === "4" ||
                        (!requester &&
                          (paramsData.disposalStatusId === "3" ||
                            paramsData.disposalStatusId === "4"))
                          ? true
                          : false
                      }
                      clearOnBlur
                      aria-label={"part-number-select"}
                      fullWidth
                      value={row}
                      options={willPolaris}
                      getOptionLabel={(option) =>
                        option.willPolarisReceiveCredit === "true"
                          ? "Yes"
                          : option.willPolarisReceiveCredit === "false"
                          ? "No"
                          : ""
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          required
                          label="Will Polaris Receive a Credit/Check for Disposal?"
                          variant="outlined"
                        />
                      )}
                      onChange={(event, options) => {
                        if (!options) {
                          return;
                        }
                        handleWillPolarisReceiveCredit(
                          options.willPolarisReceiveCredit as string
                        );
                      }}
                    />
                  </Grid>
                  <Grid item>
                    <TextField
                      disabled={
                        paramsData.disposalStatusId === "2" ||
                        paramsData.disposalStatusId === "3" ||
                        paramsData.disposalStatusId === "4" ||
                        (!requester &&
                          (paramsData.disposalStatusId === "3" ||
                            paramsData.disposalStatusId === "4"))
                          ? true
                          : false
                      }
                      fullWidth
                      value={
                        row.explainationForScrapAggrement === null ||
                        row.explainationForScrapAggrement === undefined
                          ? ""
                          : row.explainationForScrapAggrement
                      }
                      required
                      label="Explanation of Scrap Agreement"
                      variant="outlined"
                      onChange={(event) =>
                        handleExplainationForScrapAggrement(event.target.value)
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>{" "}
      </Box>
      <Grid container style={{overflow: 'auto'}} direction={"row"} justifyContent={"flex-start"}>
        <Box my={3}>
          <NewRequestToolsGrid SupplierData={totalSupplierData} /> {/* Changed to newRequestToolsGrid */}
        </Box>
      </Grid>
      <Grid container direction={"row"} justifyContent={"center"}>
        <Box my={3}>
          <NewRequestGrid SupplierData={totalSupplierData} />
          <Box mt={4}>
            <ApproveCommentModel />
          </Box>
        </Box>
      </Grid>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    autocompleteNoOptions: {
      color: theme.palette.text.primary,
    },
    inputLabel: {
      padding: theme.spacing(0.5, 0.5, 0),
    },
    clearFilterContainer: {
      marginTop: theme.spacing(2.5),
      display: "flex",
    },
    filterWrapper: {
      "& .MuiAutocomplete-noOptions": {
        color: theme.palette.text.primary,
      },
      margin: theme.spacing(0, 1, 0, 0),
      "& .MuiFormLabel-root": {
        color: theme.palette.secondary.main,
      },
    },
    inputField: {
      width: "6.25rem",
    },
    switch: {
      "& .MuiFormControlLabel-label": {
        lineHeight: "1",
      },
    },
    toggle: {
      margin: theme.spacing(0, 1),
    },
  })
);
